<template>

  <transition name="fade">


    <div :class="{'alert-big':big}">

      <div class="alert alert-info" :class="{'fade':fade,'show':fade}" v-if="show && info">
        <i class="fa fa-info-circle mr-2" aria-hidden="true"></i>
        <slot></slot>
      </div>

      <div class="alert alert-warning" :class="{'fade':fade,'show':fade}" v-if="show && warning">
        <i class="fa fa-info-circle mr-2" aria-hidden="true"></i>
        <slot></slot>
      </div>

      <div class="alert alert-success" :class="{'fade':fade,'show':fade}" v-if="show && success">
        <i class="fa fa-info-circle mr-2" aria-hidden="true"></i>
        <slot></slot>
      </div>

      <div class="alert alert-success" :class="{'fade':fade,'show':fade}"
           v-else-if="show && query && query.codSuccess === 1">
        <i class="fa fa-info-circle mr-2" aria-hidden="true"></i>
        <slot>{{ title }} {{ tWithParams('inserted-with-success', {gender: localGender, plural: localPlural}) }}</slot>
      </div>

      <div class="alert alert-success" :class="{'fade':fade,'show':fade}"
           v-else-if="show && query && query.codSuccess === 100">
        <i class="fa fa-info-circle mr-2" aria-hidden="true"></i>
        <slot>{{ query.returnMessage }}</slot>
      </div>


      <div class="alert alert-success" :class="{'fade':fade,'show':fade}"
           v-else-if="show && query && query.codSuccess === 2">
        <i class="fa fa-info-circle mr-2" aria-hidden="true"></i>
        <slot>{{ title }} {{ tWithParams('altered-with-success', {gender: localGender, plural: localPlural}) }}</slot>
      </div>
      <div class="alert alert-success" :class="{'fade':fade,'show':fade}"
           v-else-if="show && query && query.codSuccess === 3">
        <i class="fa fa-info-circle mr-2" aria-hidden="true"></i>
        <slot>{{ title }} {{ tWithParams('deleted-with-success', {gender: localGender, plural: localPlural}) }}</slot>
      </div>
      <div class="alert alert-success" :class="{'fade':fade,'show':fade}"
           v-else-if="show && query && query.codSuccess > 3">
        <i class="fa fa-info-circle mr-2" aria-hidden="true"></i>
        <slot></slot>
      </div>

      <div class="alert alert-danger" :class="{'fade':fade,'show':fade,'is-invalid-fast':invalidFast}"
           v-else-if="show && query && query.codError === 11">
        <i class="fa fa-info-circle mr-2" aria-hidden="true"></i>
        <slot>{{ t('not-have-access-include') + title }}</slot>
      </div>
      <div class="alert alert-danger" :class="{'fade':fade,'show':fade,'is-invalid-fast':invalidFast}"
           v-else-if="show && query && query.codError === 12">
        <i class="fa fa-info-circle mr-2" aria-hidden="true"></i>
        <slot>{{ t('not-have-access-change') + title }}</slot>
      </div>
      <div class="alert alert-danger" :class="{'fade':fade,'show':fade,'is-invalid-fast':invalidFast}"
           v-else-if="show && query && query.codError === 13">
        <i class="fa fa-info-circle mr-2" aria-hidden="true"></i>
        <slot>{{ t('not-have-Access-delete') + title }}</slot>
      </div>
      <div class="alert alert-danger" :class="{'fade':fade,'show':fade,'is-invalid-fast':invalidFast}"
           v-else-if="show && query && query.codError === 14">
        <i class="fa fa-info-circle mr-2" aria-hidden="true"></i>
        <slot>{{ t('not-have-access-view') + title }}</slot>
      </div>

      <div class="alert alert-danger" :class="{'fade':fade,'show':fade}"
           v-else-if="show && query && query.codError === 200">
        <i class="fa fa-info-circle mr-2" aria-hidden="true"></i>
        <slot>{{ query.returnMessage }}</slot>
      </div>


      <div class="alert alert-danger" :class="{'fade':fade,'show':fade,'is-invalid-fast':invalidFast}"
           v-else-if="(show && query && query.codError > 0) || danger">
        <i class="fa fa-info-circle mr-2" aria-hidden="true"></i>
        <slot></slot>
      </div>

    </div>


  </transition>
</template>

<script>
export default {
  name: "t-msg",
  data() {
    return {
      localGender: "a",
      localPlural: "",
      localHideSeconds: 0,
      show: true,
    }
  },
  props: {
    big: Boolean,
    fade: Boolean,
    invalidFast: Boolean,
    title: String,
    genderFeminine: Boolean,
    msg: String,
    autoHide: Boolean,
    hideSeconds: [String, Number],
    info: Boolean,
    success: Boolean,
    warning: Boolean,
    danger: Boolean,
    plural: Boolean,
    query: Object,
  },
  mounted() {

    if (this.genderFeminine) {
      this.localGender = "a"
    } else {
      this.localGender = "o"
    }

    if (this.plural) {
      this.localPlural = "s"
    }

    if (this.hideSeconds !== "0" && this.hideSeconds !== "") {
      this.localHideSeconds = parseInt(this.hideSeconds)
    }

    if (this.autoHide) {
      this.localHideSeconds = 5
    }


    if (this.localHideSeconds > 0 || (this.query && this.query.codSuccess > 0)) {
      //Retira mensagem, após X segundos

      setTimeout(() => {
        this.show = false
      }, this.localHideSeconds * 1000)

    }


  },
}
</script>

<style scoped>

</style>